import type { AppLanguage } from '../i18n/types';

const MONTH_LABELS_EN = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const;

export function monthLabelsForLanguage(language: AppLanguage): readonly string[] {
  if (language !== 'he') {
    return MONTH_LABELS_EN;
  }
  try {
    return Array.from({ length: 12 }, (_, index) =>
      new Intl.DateTimeFormat('he-IL', { month: 'long' }).format(new Date(2000, index, 1)),
    );
  } catch {
    return MONTH_LABELS_EN;
  }
}

export function daysInMonth(year: number, month1To12: number): number {
  return new Date(year, month1To12, 0).getDate();
}

export function parseIsoDateParts(s: string): { y: number; m: number; d: number } | null {
  const t = s.trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(t)) {
    return null;
  }
  const y = Number(t.slice(0, 4));
  const m = Number(t.slice(5, 7));
  const d = Number(t.slice(8, 10));
  if (!Number.isInteger(y) || !Number.isInteger(m) || !Number.isInteger(d)) {
    return null;
  }
  if (m < 1 || m > 12 || d < 1 || d > 31) {
    return null;
  }
  if (d > daysInMonth(y, m)) {
    return null;
  }
  return { y, m, d };
}

export function toIsoDate(y: number, m: number, d: number): string {
  return `${String(y).padStart(4, '0')}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}
